module.exports = __webpack_public_path__ + "static/media/prakash.ebf655be.png";